/**
 * Dropdown
 */
export class GMXDropdown extends HTMLElement {
	dropdownSelectEl: HTMLSelectElement

	private boundSelectOnChangeHandler = this._handleSelectChange.bind(this)

	connectedCallback(): void {
		this.dropdownSelectEl = this.querySelector('select')

		if (this.dropdownSelectEl) {
			this.dropdownSelectEl.addEventListener('change', this.boundSelectOnChangeHandler)
		} else {
			window.console.error(`ERROR:  GMX Dropdown missing <select> element`)
		}
	}

	disconnectedCallback(): void {
		if (this.dropdownSelectEl) {
			this.dropdownSelectEl.removeEventListener('change', this.boundSelectOnChangeHandler)
		}
	}

	/**
	 * Method to handle when the component's inner <select> element's value changes
	 * @private
	 */
	private _handleSelectChange(): void {
		if (this.dropdownSelectEl.value) {
			this.dropdownSelectEl.classList.add('filled')
		} else {
			this.dropdownSelectEl.classList.remove('filled')
		}
	}
}
if (!customElements.get('gmx-dropdown')) {
	customElements.define('gmx-dropdown', GMXDropdown)
}
